import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { v4 as uuidv4 } from "uuid";
import { LineDetailComponent } from "../line-detail/line-detail.component";
import { LineShipToComponent } from "../line-ship-to/line-ship-to.component";
import { LineItemDetailsComponent } from "../line-item-details/line-item-details.component";
import { LineVendorComponent } from "../line-vendor/line-vendor.component";
import { CommonModule, DatePipe } from "@angular/common";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { QuotesCheckCurrencyMismatchCallingMethod } from "../../../../core/models/common/checkCurrencyCallingMethod";
import { CheckCurrencyMismatchRequestDto } from "../../../../core/models/common/checkCurrencyMismatchRequestDto";
import { StockPhrase } from "../../../../core/models/orders/stockPhrase";
import { QuotesLine } from "../../../../core/models/qoutes/quoteLine";
import { QuotesLineAddressDto } from "../../../../core/models/qoutes/quotesLineAddressDto";
import { QuotesLineRequestDto } from "../../../../core/models/qoutes/quotesLineRequestDto";
import { UpdateQuotesLineDto } from "../../../../core/models/qoutes/updateQuotesLineDto";
import { Address } from "../../../../core/models/shared/address";
import { AddressCountryRegion } from "../../../../core/models/shared/countryRegionList";
import { Currency } from "../../../../core/models/shared/currencyList";
import { ShippingMethod } from "../../../../core/models/shared/shippingMethod";
import { GetAllVendorsDto } from "../../../../core/models/vendor/getAllVendors";
import { AddNewClientService } from "../../../../core/services/add-new-client.service";
import { CreateHeaderQuoteService } from "../../../../core/services/create-header-quote.service";
import { CustomerAccountService } from "../../../../core/services/customer-account.service";
import { LoaderService } from "../../../../core/services/loader.service";
import { OrderLineItemDetailService } from "../../../../core/services/order-line-item-detail.service";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { StockPhrasesComponent } from "../../../../shared/components/stock-phrases/stock-phrases.component";
import { EnumCopiedFrom } from "../../../../shared/enums/copied-From.enum";
import { ClientPurpose } from "../../../../shared/enums/enumClientPurpose";
import { QuotesHeader } from "../../../../core/models/qoutes/quotesHeader";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../../../orders/components/order-summary/order-summary.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ReleasedProduct } from "../../../../core/models/shared/releaseProduct";

@UntilDestroy()
@Component({
  selector: "jni-create-line-quote",
  imports: [
    LineVendorComponent,
    LineShipToComponent,
    ReactiveFormsModule,
    CommonModule,
    LineItemDetailsComponent,
    StockPhrasesComponent,
    ModalStackerComponent,
    OrderSummaryComponent,
    LineDetailComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
  templateUrl: "./create-line-quote.component.html",
  styleUrls: ["./create-line-quote.component.scss"],
  providers: [DatePipe],
})
export class CreateLineQuoteComponent implements OnInit, OnDestroy {
  customerLists: Address[] = [];

  deliveryAddress = [
    {
      id: 1,
      name: "To Header Ship To",
      status: false,
    },
    {
      id: 2,
      name: "To Vendor",
      status: false,
    },
    {
      id: 3,
      name: "Client Address Book",
      status: false,
    },
    {
      id: 4,
      name: "One Time",
      status: false,
    },
    {
      id: 5,
      name: "One Time Blank",
      status: false,
    },
  ];
  displayPosition = false;
  displayPositionDescription = false;
  displayPositionFactory = false;
  position:
    | "center"
    | "top"
    | "bottom"
    | "left"
    | "right"
    | "topleft"
    | "topright"
    | "bottomleft"
    | "bottomright" = "bottomright";
  displayModal = false;
  closable = false;
  quoteItemLine: FormGroup;
  currencyList: Currency[] = [];
  releasedProductsList: ReleasedProduct[] = [];
  shippingProductsList: ShippingMethod[] = [];
  countryRegionList: AddressCountryRegion[] = [];
  vendroAddressBookObject!: GetAllVendorsDto;
  quoteId = "";
  orderLineNumber = "";
  sellCurrency = "";
  lineNumber = 0;
  orderItemLineNumber = 1;
  sellCurrencyStatus = false;
  addressObject!: Address;
  headerObject!: QuotesHeader;
  compLoaded = false;
  quoteLineObject!: QuotesLine;

  quickEntyFieldStatus = "";
  customerId = "";
  shipDate = "";
  inHandDate = "";
  shippingMethod = "";
  vendorList: GetAllVendorsDto[] = [];
  stockListing: StockPhrase[] = [];
  filerStockListing: StockPhrase[] = [];
  userRoleId = 0;
  importUserRights = true;
  customerCheckbox = true;
  vendorCheckbox = true;
  vendorAccountNumber = "";
  poAssignment = "New";
  quoteOrderLine: QuotesLineAddressDto[] = [];
  currentSaleOrderLine!: Address;
  showHistory = false;
  copyCase = false;

  @ViewChild("lineDetail", { static: false })
  lineDetail!: LineDetailComponent;

  @ViewChild("shipTo", { static: false })
  shipTo!: LineShipToComponent;

  @ViewChild("details", { static: false })
  details!: LineItemDetailsComponent;

  @ViewChild("stockPhraseDescription", { static: false })
  stockPhraseDescription!: StockPhrasesComponent;

  @ViewChild("stockPhraseFactory", { static: false })
  stockPhraseFactory!: StockPhrasesComponent;

  @ViewChild("vendor", { static: false })
  vendor!: LineVendorComponent;

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input("saleOrderIdFromModal")
  set saleOrderIdFromModal(value: string) {
    this.quoteId = value;
  }

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input("orderLineNumberFromModal")
  set orderLineNumberFromModal(value: number) {
    this.orderLineNumber = String(value);
  }
  @Input() quoteModalStatus = false;
  @Output() closeEvent = new EventEmitter();
  // @Output() sellCurrencyConversionEvent = new EventEmitter<any>();
  @Output() scrollHiddenStatus = new EventEmitter();

  lineCopiedFromInfo = "";
  orderDisplayModal = false;
  copiedFromSalesOrderId = "";
  onSubmitDone = false;
  @Input() isModal = false;

  formErrors: Record<string, string> = {
    duplicateVendorDirectDelivery: "",
    itemNumberD365: "",
    orderedPurchaseQuantityD365: "",
    vendorPoAssignment: "",
    shipDate: "",
    inHandDate: "",
    addressSelectionName: "",
    deliveryNameD365: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    duplicateVendorDirectDelivery: {
      required: "Vendor is required.",
    },
    itemNumberD365: {
      required: "Category is required.",
    },
    orderedPurchaseQuantityD365: {
      required: "Quantity is required.",
    },
    vendorPoAssignment: {
      required: "PO Assignment is required.",
    },
    addressSelectionName: {
      required: "Delivery Address is required.",
    },
    shipDate: {
      required: "Ship date is required.",
    },
    inHandDate: {
      required: "In-Hands date is required.",
    },
    deliveryNameD365: {
      maxlength: "Name must be less than 100 characters.",
    },
  };

  constructor(
    private _formBuilder: FormBuilder,
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private route: Router,
    private router: ActivatedRoute,
    private _samplepoListingService: SamplepoListingService,
    private _addNewClientService: AddNewClientService,
    private _orderLineItemDetailService: OrderLineItemDetailService,
    private _customerAccountService: CustomerAccountService,
    private _createHeaderQuoteService: CreateHeaderQuoteService,
    public datepipe: DatePipe
  ) {
    this.quoteItemLine = this._formBuilder.group({
      vendor: this._formBuilder.group({
        duplicateVendorDirectDelivery: [""],
        vendorDirectDelivery: [""],
        vendorPoAssignment: ["", Validators.required],
        vendorName: [""],
        vendorAddress: [""],
        vendorPhone: [""],
        vendorEmail: [""],
        vendorFax: [""],
      }),
      shipTo: this._formBuilder.group({
        deliveryAddress: [""],
        attentionInformationD365: [""],
        countryRegionIdD365: ["", Validators.required],

        // Commented as per the ticket 11595
        zipCodeD365: [{ value: "", disabled: true }],
        //zipCodeD365: [{ value: '', disabled: true }, Validators.required],

        cityD365: [{ value: "", disabled: true }],
        stateD365: [{ value: "", disabled: true }],
        addressD365: [""],
        streetD365: [""],
        purposeD365: ClientPurpose.Business,
        isPrimaryD365: "1",
        addressBook: [""],
        buildingComplimentD365: [""],
        apartment_RUD365: [""],
        postBoxD365: [""],
        countyD365: [""],
        streetNumberD365: [""],
        districtNameD365: [""],
        shipToEmailAddress: [""],
        addressSelectionName: ["", Validators.required],
        locationD365: [""],
        addressLocationNumber: [0],
        shipToVendorAccountD365: [""],
        shipToVendorAccountNameD365: [""],
        addressFormat: [""],
        validateAddress: [""],
        rSMJNIShipToEmailD365: [""],
        melissaAddressKeyD365: [""],
        addressLine1: [""],
        addressLine2: [""],
        addressLine3: [""],
        deliveryNameD365: ["", Validators.maxLength(100)],
      }),
      detail: this._formBuilder.group({
        shippingMethod: [""],
        accountNumberD365: [""],
        shipDate: [""],
        inHandDate: ["", Validators.required],
        firm: [false],
      }),
      lines: this._formBuilder.group({
        itemNumberD365: ["", Validators.required],
        externalItemNumberD365: [""],
        orderedPurchaseQuantityD365: ["", Validators.required],
        isnetInForeignCurrencyStatus: [false],
        purchasePriceD365: [0],
        netTotalD365: [0],
        netConversion: [""],
        netConversionTotal: [""],
        sell: [0],
        sellTotal: [""],
        sellConversion: [""],
        sellConversionTotal: [""],
        commission: [0],
        grossProfit: [0],
        lineDescriptionD365: [""],
        factoryNotes: [""],
        currencyCodeD365: [""],
        rates: [0],
        locationD365: [""],
        attentionInformationD365: [""],
        isTrackable: [true],
      }),
    });

    this.router.params.subscribe((params: Params) => {
      this.quoteId = params["id"];
      this.orderLineNumber = params["linenumber"];
    });
  }

  ngOnInit(): void {
    this.disabledVendorDetailAndLineFields();
    this.getCurrencyListData();
    this.getAllReleaseProduct();
    this.getStateOfCollapseAll();
    this.getCountryRegionListData();
    this.getQuoteData();
  }

  logValidationErrors(group: FormGroup = this.quoteItemLine): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }
  showAddress = true;
  lineId = 0;
  patchValueByLineNumber(
    salesOrderLine: QuotesLineAddressDto[],
    sellCurrencyStatus: string
  ) {
    if (this.orderLineNumber) {
      const saleOrderLineList = salesOrderLine.filter(
        x => x.salesOrderLine?.id === parseInt(this.orderLineNumber)
      );
      if (saleOrderLineList.length > 0) {
        if (saleOrderLineList[0]?.salesOrderLine) {
          this.lineId = saleOrderLineList[0]?.salesOrderLine.id;
          const lineData = saleOrderLineList[0]?.salesOrderLine;
          if (saleOrderLineList[0]?.address) {
            this.currentSaleOrderLine = saleOrderLineList[0]?.address;
          }
          this.patchValueInAccountNumber(
            saleOrderLineList[0]?.salesOrderLine.accountNumberD365 ?? ""
          );
          this.patchValueInLineForm(
            saleOrderLineList[0]?.salesOrderLine,
            sellCurrencyStatus
          );
          if (
            saleOrderLineList[0]?.salesOrderLine &&
            !saleOrderLineList[0]?.salesOrderLine?.addressSelectionNameD365
              ?.toLowerCase()
              ?.includes("header")
          ) {
            this.patchValueInDeliveryName(
              saleOrderLineList[0]?.salesOrderLine.deliveryNameD365 || ""
            );
          }
          this.getSourcingVendor(
            saleOrderLineList[0]?.salesOrderLine?.vendorDirectDeliveryD365 ?? ""
          );
          if (saleOrderLineList[0]?.salesOrderLine.shipDateD365) {
            // const shipDate = saleOrderLineList[0]?.salesOrderLine.shipDateD365;
            // this.shipDate = shipDate;
            const shipDate = new Date(
              saleOrderLineList[0]?.salesOrderLine.shipDateD365
            );
            this.shipDate =
              this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";
            this.patchValueInLineShipDate(this.shipDate);
          } else {
            this.shipDate = "";
          }
          if (saleOrderLineList[0]?.salesOrderLine.inHandDateD365) {
            // const inHandDate =
            //   saleOrderLineList[0]?.salesOrderLine.inHandDateD365;
            // this.inHandDate = inHandDate;
            const inHandDate = new Date(
              saleOrderLineList[0]?.salesOrderLine.inHandDateD365
            );
            this.inHandDate =
              this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
            this.patchValueInLineHandDate(this.inHandDate);
          } else {
            this.inHandDate = "";
          }
          if (saleOrderLineList[0]?.salesOrderLine.shippingMethodD365) {
            this.shippingMethod =
              saleOrderLineList[0]?.salesOrderLine.shippingMethodD365;
            this.patchValueInShippingMethod(this.shippingMethod);
          }
          if (lineData.accountNumberD365) {
            this.patchValueInAccountNumber(lineData.accountNumberD365);
          }
          if (saleOrderLineList[0]?.salesOrderLine.firmD365) {
            this.patchValueInFirm(
              saleOrderLineList[0]?.salesOrderLine.firmD365 === 1 ? true : false
            );
          }
        }
        if (saleOrderLineList[0]?.address) {
          if (
            saleOrderLineList[0]?.salesOrderLine?.addressSelectionNameD365
              ?.toLowerCase()
              .includes("one")
          ) {
            this.showAddress = false;
          }

          if (
            !saleOrderLineList[0]?.salesOrderLine?.addressSelectionNameD365
              ?.toLowerCase()
              .includes("header")
          ) {
            this.patchValueInLineAddressForm(saleOrderLineList[0]?.address);
          }
        }
        this.deliveryAddress[2].status = false;
      }
    }
  }

  patchValueInAccountNumber(accountNumber: string) {
    this.quoteItemLine.patchValue({
      detail: {
        accountNumberD365: accountNumber,
      },
    });
  }

  patchValueInLineShipDate(date: string) {
    this.quoteItemLine.patchValue({
      detail: {
        shipDate: date,
      },
    });
  }
  patchValueInLineHandDate(date: string) {
    this.quoteItemLine.patchValue({
      detail: {
        inHandDate: date,
      },
    });
  }

  applylineDescriptionLengthValidation(event: Event) {
    const eventTarget = event.target as HTMLInputElement;
    if (eventTarget.value) {
      this.quoteItemLine.patchValue({
        lines: {
          lineDescriptionD365: eventTarget.value.substring(0, 2000),
        },
      });
    }
  }

  patchValueInDeliveryName(name: string) {
    this.quoteItemLine.patchValue({
      shipTo: {
        deliveryNameD365: name,
      },
    });
  }

  applyfactoryNotesLengthValidation(event: Event) {
    const eventTarget = event.target as HTMLInputElement;

    if (eventTarget.value) {
      this.quoteItemLine.patchValue({
        lines: {
          factoryNotes: eventTarget.value.substring(0, 2000),
        },
      });
    }
  }

  getSourcingVendor(accountNumberOrName: string) {
    this._samplepoListingService
      .getVendorByNameAndAccountNumberFilter(accountNumberOrName)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.vendorList = res?.data as unknown as GetAllVendorsDto[];
          if (this.vendorList && this.vendorList.length > 0) {
            this.vendroAddressBookObject = this.vendorList[0];
            this.patchValueInVendor(this.vendorList[0]);
            this.patchValueInVendorAccount(accountNumberOrName);
            this.patchValueInVendorAddress(
              this.vendorList[0].partyNumber ?? "",
              accountNumberOrName
            );
            this.getVendorObject(this.vendroAddressBookObject);
          }
        },
      });
  }

  netFieldStatus = true;
  getVendorObject(event: GetAllVendorsDto) {
    this.vendroAddressBookObject = event;
    this.quoteItemLine.get(["lines", "isnetInForeignCurrencyStatus"])?.enable();
    this.netFieldStatus = false;
    if (this.vendroAddressBookObject.vendorAccountNumber) {
      this.vendorCheckbox = false;
      this.vendorAccountNumber =
        this.vendroAddressBookObject.vendorAccountNumber;
    }
    this.lineDetail.enableNetField();
  }

  patchValueInVendorAccount(vendorAccount: string) {
    this.quoteItemLine.patchValue({
      vendor: {
        vendorDirectDelivery: vendorAccount,
        duplicateVendorDirectDelivery: vendorAccount,
      },
    });
  }

  patchValueInVendorAddress(partyNumber: string, accountNumber: string) {
    this._samplepoListingService
      .getVendorAddressByPartyNumber(partyNumber, accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const primaryAddress = res.data.filter(
            x =>
              x.isPrimaryD365?.toLowerCase() === "yes" ||
              x.isPrimaryD365?.toLowerCase() === "1"
          );
          if (primaryAddress.length > 0) {
            if (primaryAddress[0].addressD365) {
              this.patchValuesInVendorFormAddressField(
                primaryAddress[0].addressD365
              );
            }
          }
        },
      });
  }

  patchValuesInVendorFormAddressField(address: string) {
    this.quoteItemLine.patchValue({
      vendor: {
        vendorAddress: address,
      },
    });
  }

  patchValueInVendor(vendorObject: GetAllVendorsDto) {
    this.quoteItemLine.patchValue({
      vendor: {
        vendorName: vendorObject.vendorName,
        vendorPhone: vendorObject.phoneNumber,
        vendorEmail: vendorObject.emailAddress,
        vendorFax: vendorObject.fax,
      },
    });
  }

  patchValueInLineForm(
    salesOrderLineObject: QuotesLine,
    sellCurrencyStatus: string
  ) {
    if (
      salesOrderLineObject?.lineCopiedFrom &&
      salesOrderLineObject.lineCopiedFrom &&
      salesOrderLineObject.lineCopiedFromHeaderId
    ) {
      this.showHistory = true;
      this.quoteLineObject = salesOrderLineObject;
    }
    this.quoteItemLine.patchValue({
      vendor: {
        vendorDirectDelivery: salesOrderLineObject.vendorDirectDeliveryD365,
        vendorPoAssignment: salesOrderLineObject.vendorPoAssignmentD365 ?? "",
      },
      lines: {
        itemNumberD365: salesOrderLineObject.itemNumberD365 ?? "",
        externalItemNumberD365:
          salesOrderLineObject.externalItemNumberD365 ?? "",
        orderedPurchaseQuantityD365:
          salesOrderLineObject.orderedPurchaseQuantityD365 ?? "",
        isnetInForeignCurrencyStatus:
          salesOrderLineObject.isnetInForeignCurrencyStatus ?? false,
        purchasePriceD365: salesOrderLineObject.purchasePriceD365 ?? "",
        netTotalD365: salesOrderLineObject.netTotalD365 ?? "",
        netConversion: salesOrderLineObject.netConversion ?? "",
        netConversionTotal: salesOrderLineObject.netConversionTotalD365 ?? "",
        sell: salesOrderLineObject.sellD365 ?? "",
        sellTotal: salesOrderLineObject.sellTotalD365 ?? "",
        sellConversion: salesOrderLineObject.sellConversion ?? "",
        sellConversionTotal: salesOrderLineObject.sellConversionTotal ?? "",
        commission: salesOrderLineObject.commissionD365 ?? "",
        grossProfit: salesOrderLineObject.grossProfitD365 ?? "",
        lineDescriptionD365: salesOrderLineObject.lineDescriptionD365 ?? "",
        factoryNotes: salesOrderLineObject.factoryNotesD365 ?? "",
        currencyCodeD365: salesOrderLineObject.currencyCodeD365 ?? "",
        rates: salesOrderLineObject.rates ?? "",
        isTrackable: salesOrderLineObject.isTrackable ?? false,
      },
    });

    if (
      !salesOrderLineObject?.addressSelectionNameD365
        ?.toLowerCase()
        ?.includes("header")
    ) {
      this.quoteItemLine.patchValue({
        shipTo: {
          attentionInformationD365:
            salesOrderLineObject.attentionInformationD365,
          //addressSelectionName: salesOrderLineObject.addressSelectionNameD365,
          locationD365: salesOrderLineObject.locationD365,
          addressLocationNumber: salesOrderLineObject.addressLocationNumberD365,
          shipToVendorAccountD365: salesOrderLineObject.shipToVendorAccountD365,
          rSMJNIShipToEmailD365: salesOrderLineObject.rsmjniShipToEmailD365,
        },
      });
    }

    this.lineDetail.patchValueInLines(salesOrderLineObject, sellCurrencyStatus);
    this.shipTo.showAddressFieldLineSelection(
      salesOrderLineObject.addressSelectionNameD365 ?? ""
    );
    this.shipTo.getVendorByName(
      salesOrderLineObject.shipToVendorAccountD365 ?? ""
    );

    if (salesOrderLineObject.vendorPoAssignmentD365) {
      this.poAssignment = salesOrderLineObject.vendorPoAssignmentD365;
    }

    this.patchValueInaddressSelection(
      salesOrderLineObject.addressSelectionNameD365 ?? ""
    );

    if (
      salesOrderLineObject?.itemNumberD365?.toLowerCase() === "setup" ||
      salesOrderLineObject?.itemNumberD365?.toLowerCase() === "set up"
    ) {
      this.quoteItemLine.get(["lines", "isTrackable"])?.disable();
    }
  }

  patchValueInaddressSelection(addressSelectionName: string) {
    // let addressBook = '';
    // if (addressSelectionName.toLowerCase().includes('address book')) {
    //   addressBook = 'Client Address Book';
    // } else {
    //   addressBook = addressSelectionName;
    // }
    let addressBook = "";
    if (addressSelectionName.toLowerCase().includes("address book")) {
      addressBook = "Client Address Book";
    } else if (addressSelectionName.toLowerCase().includes("header ship")) {
      addressBook = "To Header Ship To";
    } else if (addressSelectionName.toLowerCase().includes("vendor")) {
      addressBook = "To Vendor";
    } else if (addressSelectionName.toLowerCase().includes("one time")) {
      addressBook = "One Time";
    } else if (addressSelectionName.toLowerCase().includes("blank")) {
      addressBook = "One Time Blank";
    } else {
      addressBook = addressSelectionName;
    }
    this.quoteItemLine.patchValue({
      shipTo: {
        addressSelectionName: addressBook,
      },
    });

    if (!addressBook?.toLowerCase()?.includes("header")) {
      this.shipTo.enableAttentionandLocationField();
    }
  }

  patchValueInLineAddressForm(salesOrderLineAddressObject: Address) {
    this.quoteItemLine.patchValue({
      shipTo: {
        countryRegionIdD365: salesOrderLineAddressObject.countryRegionIdD365,
        zipCodeD365: salesOrderLineAddressObject.zipCodeD365,
        cityD365: salesOrderLineAddressObject.cityD365,
        stateD365: salesOrderLineAddressObject.stateD365,
        streetD365: salesOrderLineAddressObject.streetD365,
        buildingComplimentD365:
          salesOrderLineAddressObject.buildingComplimentD365,
        postBoxD365: salesOrderLineAddressObject.postBoxD365,
        countyD365: salesOrderLineAddressObject.countyD365,
        streetNumberD365: salesOrderLineAddressObject.streetNumberD365,
        districtNameD365: salesOrderLineAddressObject.districtNameD365,
        addressLocationName:
          salesOrderLineAddressObject.addressLocationNameD365,
        addressD365: salesOrderLineAddressObject.addressD365,
      },
    });
  }

  getCountryRegionListData() {
    this._addNewClientService
      .getCountryRegionList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countryRegionList = res?.data;
        },
      });
  }

  disabledVendorDetailAndLineFields() {
    this.quoteItemLine.get(["vendor", "vendorName"])?.disable();
    this.quoteItemLine.get(["vendor", "vendorAddress"])?.disable();
    this.quoteItemLine.get(["vendor", "vendorPhone"])?.disable();
    this.quoteItemLine.get(["vendor", "vendorEmail"])?.disable();
    this.quoteItemLine.get(["vendor", "vendorFax"])?.disable();
    this.quoteItemLine.get(["lines", "commission"])?.disable();
    this.quoteItemLine.get(["lines", "grossProfit"])?.disable();
  }

  getVendorAccountField(event: Event) {
    const eventTarget = event.target as HTMLInputElement;
    if (eventTarget.value != "") {
      this.deliveryAddress[2].status = false;
    } else {
      this.deliveryAddress[2].status = true;
    }
  }

  getAllReleaseProduct() {
    this._samplepoListingService
      .getAllCategory()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.releasedProductsList = res.data.filter(
            x => x.itemNumberD365 != "Misc" && x.productTypeD365 === "Service"
          );
        },
      });
  }

  getCurrencyListData() {
    this._addNewClientService
      .getCurrencyList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.currencyList = res.data;
        },
      });
  }

  getAllShippingMethod() {
    this._samplepoListingService
      .getAllShippingMethod()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const shippingData = res.data;
          this.shippingProductsList = shippingData.filter(
            x => x.jniUseOnSalesOrderD365 !== "No"
          );
          if (this.shippingMethod) {
            this.onShippingMethodSelect(this.shippingMethod);
          }
        },
      });
  }

  redirectToSummary() {
    if (this.quoteModalStatus) {
      this.closeEvent.emit();
      return;
    } else {
      this.route.navigate(["proposal/quote-summary/" + this.quoteId]);
    }
  }

  getQuoteData() {
    this._loaderService.setLoaderState(true);
    this._createHeaderQuoteService
      .getQuotesData(this.quoteId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.compLoaded = true;
          if (res.data) {
            if (
              res.data.salesOrderHeader?.salesOrderHeader?.foreignCurrencyD365
            ) {
              this.sellCurrency =
                res.data.salesOrderHeader?.salesOrderHeader?.foreignCurrencyD365;
            }
            if (
              res.data.salesOrderHeader?.salesOrderHeader?.foreignCurrencyStatus
            ) {
              this.sellCurrencyStatus =
                res.data.salesOrderHeader?.salesOrderHeader?.foreignCurrencyStatus;
            }
            if (
              res.data.salesOrderHeader?.salesOrderHeader?.addressSelectionD365
            ) {
              this.customerId =
                res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365 ??
                "";
              if (this.customerId) {
                this.customerCheckbox = false;
              }
            }
            if (
              res.data.salesOrderHeader?.salesOrderHeader?.approvalStatusD365 ==
                null ||
              res.data.salesOrderHeader?.salesOrderHeader?.approvalStatusD365 ==
                "" ||
              res.data.salesOrderHeader?.salesOrderHeader?.approvalStatusD365.toLowerCase() ==
                "none"
            ) {
              this.vendor.poAssignmentStatus();
            }
            if (
              !this.quickEntyFieldStatus?.includes("Copy Header") &&
              !this.quickEntyFieldStatus?.includes("Copy Line") &&
              !this.quickEntyFieldStatus?.includes("Add Setup")
            ) {
              if (
                res.data.salesOrderHeader?.address &&
                !(
                  res.data?.salesOrderHeader?.salesOrderHeader?.addressSelectionD365
                    ?.toLowerCase()
                    .includes("multi") ||
                  res.data?.salesOrderHeader?.salesOrderHeader?.addressSelectionD365
                    ?.toLowerCase()
                    .includes("tbd")
                )
              ) {
                this.addressObject = res.data.salesOrderHeader.address;
                this.shipTo.onDeliveryAddressChange("To header ship to");
                this.shipTo.patchFormInHeaderToShip(this.addressObject);
                this.shipTo.patchFormDeliveryAddress("To header ship to", "");
              } else {
                const addressSelection =
                  res.data.salesOrderHeader?.salesOrderHeader
                    ?.addressSelectionD365;
                this.shipTo.patchFormDeliveryAddress(
                  "To Header Ship To",
                  addressSelection ?? ""
                );
              }
              if (res.data.salesOrderHeader?.salesOrderHeader) {
                this.headerObject = res.data.salesOrderHeader.salesOrderHeader;
                if (
                  this.headerObject?.addressSelectionD365
                    ?.toLowerCase()
                    ?.includes("multi")
                ) {
                  this.headerObject.deliveryNameD365 = "Multiple Drop Ships";
                } else if (
                  this.headerObject?.addressSelectionD365
                    ?.toLowerCase()
                    ?.includes("tbd")
                ) {
                  this.headerObject.deliveryNameD365 = "TBD";
                }
                this.shipTo.patchFormInHeaderToShipAddress(this.headerObject);
              }
            }

            this.getAllShippingMethod();
            if (
              res.data.salesOrderHeader?.salesOrderHeader?.shippingMethodD365
            ) {
              this.shippingMethod =
                res.data.salesOrderHeader?.salesOrderHeader?.shippingMethodD365;
              this.patchValueInShippingMethod(this.shippingMethod);
            }

            if (res.data.salesOrderHeader?.salesOrderHeader?.account) {
              this.patchValueInAccountNumber(
                res.data.salesOrderHeader.salesOrderHeader.account
              );
            }

            if (res.data.salesOrderLine) {
              if (res.data.salesOrderLine.length > 0) {
                this.quoteOrderLine = res.data.salesOrderLine;
                if (this.orderLineNumber) {
                  const saleOrderLineList = res?.data?.salesOrderLine.filter(
                    x => x.salesOrderLine?.id === parseInt(this.orderLineNumber)
                  );
                  if (saleOrderLineList[0]?.salesOrderLine) {
                    const number =
                      saleOrderLineList[0]?.salesOrderLine?.lineNumberD365;
                    this.orderItemLineNumber = number ?? 1;
                  }
                } else {
                  this.getLineNumber(this.quoteId);
                }
                this.patchValueByLineNumber(
                  res.data.salesOrderLine,
                  this.sellCurrency
                );
              }
            }
            if (this.quoteOrderLine.length > 0 && !this.orderLineNumber) {
              this.checkPOAssignment();
            }
            if (this.sellCurrencyStatus) {
              this.lineDetail.getSellCurrency(this.sellCurrency);
            }
            if (res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365) {
              this._createHeaderQuoteService
                .getPartyNumberByAccountNumber(
                  res.data.salesOrderHeader?.salesOrderHeader.customerIdD365
                )
                .subscribe(x => {
                  this.patchValueInCustomerAddressField(
                    res.data.salesOrderHeader?.salesOrderHeader
                      ?.customerIdD365 ?? "",
                    x.data ?? ""
                  );
                });
            }
          } else {
            this._toastr.error("Error", res.message ?? "Data not found");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message ?? "Data not found");
        },
      });
  }

  checkPOAssignment() {
    if (this.quoteOrderLine.length > 0) {
      const vendorNumber = this.quoteItemLine.get([
        "vendor",
        "vendorDirectDelivery",
      ])?.value;

      let lineStatus = false;
      this.quoteOrderLine.forEach(x => {
        if (x.salesOrderLine?.vendorDirectDeliveryD365 === vendorNumber) {
          lineStatus = true;
        }
      });
      if (lineStatus) {
        this.poAssignment = "Default";
        this.patchValueInPoAssignment(this.poAssignment);
      } else {
        this.poAssignment = "New";
        this.patchValueInPoAssignment(this.poAssignment);
      }
    }
  }

  patchValueInPoAssignment(poAssigment: string) {
    this.quoteItemLine.patchValue({
      vendor: {
        vendorPoAssignment: poAssigment,
      },
    });
  }

  patchValueInCustomerAddressField(accountNumber: string, partyNumber: string) {
    this._customerAccountService
      .getCustomerAddressByPartyNumber(partyNumber, accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const primaryAddress = res.data.filter(
            x =>
              x.isPrimaryD365?.toLowerCase() === "yes" ||
              x.isPrimaryD365?.toLowerCase() === "1" ||
              x.rolesD365?.toLowerCase() === "delivery"
          );
          this.customerLists = primaryAddress;
          const currentClientObject = this.customerLists?.filter(
            x =>
              x?.locationNumberD365 ===
                this.currentSaleOrderLine?.locationNumberD365 &&
              x?.addressD365 === this.currentSaleOrderLine?.addressD365
          );
          if (currentClientObject?.length > 0) {
            this.shipTo.patchValueInCustomerShipToName(
              currentClientObject[0]?.descriptionD365 ?? ""
            );
          }
        },
      });
  }

  patchValueInFirm(firm: boolean) {
    this.quoteItemLine.patchValue({
      detail: {
        firm: firm,
      },
    });
  }

  onShippingMethodSelect(shippingMethodCode: string) {
    if (!this.orderLineNumber) {
      const index = this.shippingProductsList.findIndex(
        x => x.modeCodeD365 == shippingMethodCode
      );

      if (index > -1) {
        const selectedShippingMethod = this.shippingProductsList[index];
        if (
          selectedShippingMethod.useFreightAccountD365?.toLowerCase() == "yes"
        ) {
          this.quoteItemLine.patchValue({
            detail: {
              accountNumberD365: selectedShippingMethod.jniFreightAcctNumD365,
            },
          });
        } else {
          this._orderLineItemDetailService
            .getClientFreightAccountNumber(this.customerId)
            .subscribe({
              next: res => {
                if (res.data) {
                  this.quoteItemLine.patchValue({
                    detail: {
                      accountNumberD365: res.data,
                    },
                  });
                }
              },
            });
        }
      }
    }
  }

  patchValueInShippingMethod(shippingMethod: string) {
    this.quoteItemLine.patchValue({
      detail: {
        shippingMethod: shippingMethod,
      },
    });
  }

  patchValueInShipDate(shipdate: string) {
    this.quoteItemLine.patchValue({
      detail: {
        shipDate: shipdate,
      },
    });
  }

  patchValueInHandDate(inhandate: string) {
    this.quoteItemLine.patchValue({
      detail: {
        inHandDate: inhandate,
      },
    });
  }

  getLineNumber(quoteId: string) {
    return this._createHeaderQuoteService
      .getSaleOrderLineNumber(quoteId)
      .subscribe({
        next: x => {
          this.orderItemLineNumber = x.data ?? 1;
        },
      });
  }

  submitButtonlogValidationErrors(group: FormGroup = this.quoteItemLine): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.submitButtonlogValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (abstractControl && !abstractControl.valid) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  next(lineAction: string) {
    this.submitButtonlogValidationErrors();
    this._loaderService.setLoaderState(true);

    //////// #13049
    if (lineAction === "Add Setup") {
      this.quoteItemLine.get(["lines", "isTrackable"])?.setValue(false);
      this.quoteItemLine.get(["lines", "isTrackable"])?.disable();
    }

    const quoteLineFormObject = this.quoteItemLine.getRawValue();
    if (lineAction === "Copy Header" || lineAction === "Copy Line") {
      quoteLineFormObject.vendor.vendorPoAssignment = "Default";
      this.poAssignment = "Default";
      this.patchValueInPoAssignment(this.poAssignment);
      this.quoteItemLine.patchValue({
        vendor: {
          vendorPoAssignment: "Default",
        },
      });
    }
    quoteLineFormObject.lines.portalKey = uuidv4();
    const linesArray = [];
    linesArray.push(quoteLineFormObject.lines);

    if (quoteLineFormObject.detail && !quoteLineFormObject.detail.shipDate) {
      // this._loaderService.setLoaderState(false);
      // this._toastr.error('Error', 'Ship date is required');
      // return;
      quoteLineFormObject.detail.shipDate = "";
    }

    if (!quoteLineFormObject.detail?.inHandDate) {
      this._loaderService.setLoaderState(false);
      this._toastr.error("Error", "Inhand date is required");
      return;
    }

    if (
      quoteLineFormObject.detail?.shipDate &&
      quoteLineFormObject.detail?.inHandDate
    ) {
      if (
        new Date(quoteLineFormObject.detail?.inHandDate) <
        new Date(quoteLineFormObject.detail?.shipDate)
      ) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          "Inhands date should be greater and equal to ship date"
        );
        return;
      }
    }

    if (
      quoteLineFormObject.shipTo &&
      quoteLineFormObject.shipTo.addressLocationNumber === 0
    ) {
      quoteLineFormObject.shipTo.addressLocationNumber = 0;
    }

    if (
      quoteLineFormObject?.shipTo &&
      !quoteLineFormObject.shipTo?.addressSelectionName
    ) {
      this._toastr.error("Error", "Ship To Delivery is required");
      this._loaderService.setLoaderState(false);
      return;
    }

    const addressD365 = this.headerObject?.addressSelectionD365 ?? "";
    if (
      addressD365 &&
      (addressD365?.toLowerCase()?.includes("multi") ||
        addressD365?.toLowerCase()?.includes("drop") ||
        addressD365?.toLowerCase()?.includes("tbd"))
    ) {
      quoteLineFormObject.shipTo.addressD365 = "";
    }

    if (
      !(
        quoteLineFormObject.shipTo?.addressSelectionName ==
          "To Header Ship To" &&
        (this.headerObject.addressSelectionD365 == "TBD" ||
          this.headerObject.addressSelectionD365 == "Multiple ship-to" ||
          this.headerObject.addressSelectionD365?.includes("drop") ||
          this.headerObject.addressSelectionD365 == "Multi Ship To")
      )
    ) {
      if (!quoteLineFormObject.shipTo.countryRegionIdD365) {
        this._toastr.error("Error", "Address is required");
        this._loaderService.setLoaderState(false);
        return;
      }
      if (
        !quoteLineFormObject.shipTo.zipCodeD365 &&
        quoteLineFormObject.shipTo.countryRegionIdD365 === "USA"
      ) {
        this._toastr.error("Error", "Address is required");
        this._loaderService.setLoaderState(false);
        return;
      }
    }

    if (quoteLineFormObject.lines.commission === 0) {
      quoteLineFormObject.lines.commission = 0;
    }

    if (quoteLineFormObject.lines.grossProfit === 0) {
      quoteLineFormObject.lines.grossProfit = 0;
    }
    if (quoteLineFormObject.lines.orderedPurchaseQuantityD365 === 0) {
      this._toastr.error("Error", "Quantity required");
      this._loaderService.setLoaderState(false);
      return;
    }
    if (
      (quoteLineFormObject?.shipTo?.addressSelectionName as string)
        ?.toLowerCase()
        .includes("one")
    ) {
      quoteLineFormObject.shipTo.addressLocationNumber = 0;
    }

    if (!this.quoteItemLine.valid) {
      this._loaderService.setLoaderState(false);
      return;
    }

    if (
      this.lineId &&
      !["Add Line", "Copy Header", "Copy Line", "Add Setup"].includes(
        lineAction
      )
    ) {
      const updateQuoteLineRequest: UpdateQuotesLineDto = {
        id: this.lineId,
        vendor: quoteLineFormObject.vendor,
        shipTo: quoteLineFormObject.shipTo,
        Detail: quoteLineFormObject.detail,
        lines: linesArray[0],
      };

      if (updateQuoteLineRequest.shipTo) {
        const formValue = this.quoteItemLine.getRawValue();
        const value = formValue.shipTo.shipToVendorAccountNameD365 ?? "";
        updateQuoteLineRequest.shipTo.deliveryAddressD365 =
          this.getDeliveryAddress(
            updateQuoteLineRequest.shipTo.addressSelectionName ?? "",
            updateQuoteLineRequest.shipTo.deliveryNameD365 ?? "",
            value ?? ""
          );
      }

      this.checkCurrencyMismatch(
        updateQuoteLineRequest,
        QuotesCheckCurrencyMismatchCallingMethod.nextMethodUpdateQuoteLine,
        ""
      );
    } else {
      const addQuoteLineRequest: QuotesLineRequestDto = {
        purchaseOrderId: "",
        saleOrderId: this.quoteId,
        vendor: quoteLineFormObject.vendor,
        shipTo: quoteLineFormObject.shipTo,
        Detail: quoteLineFormObject.detail,
        lines: linesArray,
      };

      if (addQuoteLineRequest.shipTo) {
        const formValue = this.quoteItemLine.getRawValue();
        const value = formValue.shipTo.shipToVendorAccountNameD365 ?? "";
        addQuoteLineRequest.shipTo.deliveryAddressD365 =
          this.getDeliveryAddress(
            addQuoteLineRequest.shipTo.addressSelectionName ?? "",
            addQuoteLineRequest.shipTo.deliveryNameD365 ?? "",
            value ?? ""
          );
      }

      if (lineAction === "Add Setup" && this.lineId === 0) {
        this.copyCase = true;
      }

      this.checkCurrencyMismatch(
        addQuoteLineRequest,
        QuotesCheckCurrencyMismatchCallingMethod.nextMethodCreateQuoteLine,
        lineAction
      );
    }
  }

  unTouchForm() {
    this.quoteItemLine.markAsUntouched();
    this.quoteItemLine.markAsPristine();
    this.formErrors = {
      duplicateVendorDirectDelivery: "",
      itemNumberD365: "",
      orderedPurchaseQuantityD365: "",
      vendorPoAssignment: "",
      shipDate: "",
      inHandDate: "",
      addressSelectionName: "",
    };
  }

  clearLineData() {
    this.quoteItemLine.patchValue({
      lines: {
        itemNumberD365: "",
        externalItemNumberD365: "",
        orderedPurchaseQuantityD365: "",
        isnetInForeignCurrencyStatus: false,
        purchasePriceD365: 0,
        netTotalD365: 0,
        netConversion: "",
        netConversionTotal: "",
        sell: 0,
        sellTotal: "",
        sellConversion: "",
        sellConversionTotal: "",
        commission: 0,
        grossProfit: 0,
        lineDescriptionD365: "",
        factoryNotes: "",
        currencyCodeD365: "",
        rates: 0,
      },
    });
  }

  clearSaleOrderLineForm() {
    this.quoteItemLine.patchValue({
      vendor: {
        duplicateVendorDirectDelivery: "",
        vendorDirectDelivery: "",
        // vendorPoAssignment: '',
        vendorName: "",
        vendorAddress: "",
        vendorPhone: "",
        vendorEmail: "",
        vendorFax: "",
      },
      // shipTo: {
      //   deliveryAddress: '',
      //   attentionInformationD365: '',
      //   countryRegionIdD365: '',
      //   zipCodeD365: '',
      //   cityD365: '',
      //   stateD365: '',
      //   addressD365: '',
      //   streetD365: '',
      //   shipToEmail: '',
      //   addressBook: '',
      //   buildingComplimentD365: '',
      //   apartment_RUD365: '',
      //   postBoxD365: '',
      //   countyD365: '',
      //   streetNumberD365: '',
      //   districtNameD365: '',
      //   shipToEmailAddress: '',
      //   addressSelectionName: '',
      //   locationD365: ''
      // },
      detail: {
        firm: false,
      },
      lines: {
        itemNumberD365: "",
        externalItemNumberD365: "",
        orderedPurchaseQuantityD365: "",
        isnetInForeignCurrencyStatus: false,
        purchasePriceD365: 0,
        netTotalD365: 0,
        netConversion: "",
        netConversionTotal: "",
        sell: 0,
        sellTotal: "",
        sellConversion: "",
        sellConversionTotal: "",
        commission: 0,
        grossProfit: 0,
        lineDescriptionD365: "",
        factoryNotes: "",
        currencyCodeD365: "",
        rates: 0,
      },
    });
  }

  patchValueInSetup() {
    this.quoteItemLine.patchValue({
      lines: {
        itemNumberD365: "Set Up",
        externalItemNumberD365: "setup",
        orderedPurchaseQuantityD365: 1,
        lineDescriptionD365: "setup",
        factoryNotes: "setup",
      },
    });
  }

  onSubmit() {
    this.submitButtonlogValidationErrors();
    this.onSubmitDone = true;
    this._loaderService.setLoaderState(true);
    const quoteLineFormObject = this.quoteItemLine.getRawValue();
    quoteLineFormObject.lines.portalKey = uuidv4();
    const linesArray = [];
    linesArray.push(quoteLineFormObject.lines);

    if (quoteLineFormObject.detail && !quoteLineFormObject.detail.shipDate) {
      // this._loaderService.setLoaderState(false);
      // this._toastr.error('Error', 'Ship date is required');
      // return;
      quoteLineFormObject.detail.shipDate = "";
    }

    if (!quoteLineFormObject.detail?.inHandDate) {
      this._loaderService.setLoaderState(false);
      this._toastr.error("Error", "Inhand date is required");
      return;
    }

    if (
      quoteLineFormObject.detail?.shipDate &&
      quoteLineFormObject.detail?.inHandDate
    ) {
      if (
        new Date(quoteLineFormObject.detail?.inHandDate) <
        new Date(quoteLineFormObject.detail?.shipDate)
      ) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          "Inhands date should be greater and equal to ship date"
        );
        return;
      }
    }

    if (
      quoteLineFormObject.shipTo &&
      quoteLineFormObject.shipTo.addressLocationNumber === 0
    ) {
      quoteLineFormObject.shipTo.addressLocationNumber = 0;
    }

    if (
      quoteLineFormObject?.shipTo &&
      !quoteLineFormObject.shipTo?.addressSelectionName
    ) {
      this._toastr.error("Error", "Ship To Delivery is required");
      this._loaderService.setLoaderState(false);
      return;
    }

    const addressD365 = this.headerObject?.addressSelectionD365 ?? "";
    if (
      addressD365 &&
      (addressD365?.toLowerCase()?.includes("multi") ||
        addressD365?.toLowerCase()?.includes("drop") ||
        addressD365?.toLowerCase()?.includes("tbd"))
    ) {
      quoteLineFormObject.shipTo.addressD365 = "";
    }

    if (
      !(
        quoteLineFormObject.shipTo?.addressSelectionName ==
          "To Header Ship To" &&
        (this.headerObject.addressSelectionD365 == "TBD" ||
          this.headerObject.addressSelectionD365 == "Multiple ship-to" ||
          this.headerObject.addressSelectionD365
            ?.toLowerCase()
            .includes("drop") ||
          this.headerObject.addressSelectionD365 == "Multi Ship To")
      )
    ) {
      if (!quoteLineFormObject.shipTo.countryRegionIdD365) {
        this._toastr.error("Error", "Address is required");
        this._loaderService.setLoaderState(false);
        return;
      }
      if (
        !quoteLineFormObject.shipTo.zipCodeD365 &&
        quoteLineFormObject.shipTo.countryRegionIdD365 === "USA"
      ) {
        this._toastr.error("Error", "Address is required");
        this._loaderService.setLoaderState(false);
        return;
      }
    }

    if (quoteLineFormObject.lines.commission === 0) {
      quoteLineFormObject.lines.commission = 0;
    }

    if (quoteLineFormObject.lines.grossProfit === 0) {
      quoteLineFormObject.lines.grossProfit = 0;
    }

    if (quoteLineFormObject.lines.orderedPurchaseQuantityD365 === 0) {
      this._toastr.error("Error", "Quantity required");
      this._loaderService.setLoaderState(false);
      return;
    }

    if (quoteLineFormObject.shipTo.attentionInformationD365) {
      quoteLineFormObject.lines.attentionInformationD365 =
        quoteLineFormObject.shipTo.attentionInformationD365;
    }
    if (quoteLineFormObject.shipTo.locationD365) {
      quoteLineFormObject.lines.locationD365 =
        quoteLineFormObject.shipTo.locationD365;
    }

    if (
      (quoteLineFormObject.shipTo.addressSelectionName as string)
        ?.toLowerCase()
        .includes("one")
    ) {
      quoteLineFormObject.shipTo.addressLocationNumber = 0;
    }

    if (!this.quoteItemLine.valid) {
      this._loaderService.setLoaderState(false);
      return;
    }

    if (this.lineId) {
      const updateQuoteLineRequest: UpdateQuotesLineDto = {
        id: this.lineId,
        vendor: quoteLineFormObject.vendor,
        shipTo: quoteLineFormObject.shipTo,
        Detail: quoteLineFormObject.detail,
        lines: linesArray[0],
      };

      if (updateQuoteLineRequest.shipTo) {
        const formValue = this.quoteItemLine.getRawValue();
        const value = formValue.shipTo.shipToVendorAccountNameD365 ?? "";
        updateQuoteLineRequest.shipTo.deliveryAddressD365 =
          this.getDeliveryAddress(
            updateQuoteLineRequest.shipTo.addressSelectionName ?? "",
            updateQuoteLineRequest.shipTo.deliveryNameD365 ?? "",
            value ?? ""
          );
      }

      this.checkCurrencyMismatch(
        updateQuoteLineRequest,
        QuotesCheckCurrencyMismatchCallingMethod.onSubmitMethodUpdateQuoteLine,
        ""
      );
    } else {
      const addQuoteLineRequest: QuotesLineRequestDto = {
        saleOrderId: this.quoteId,
        vendor: quoteLineFormObject.vendor,
        shipTo: quoteLineFormObject.shipTo,
        Detail: quoteLineFormObject.detail,
        lines: linesArray,
        purchaseOrderId: "",
      };

      if (addQuoteLineRequest.shipTo) {
        const formValue = this.quoteItemLine.getRawValue();
        const value = formValue.shipTo.shipToVendorAccountNameD365 ?? "";
        addQuoteLineRequest.shipTo.deliveryAddressD365 =
          this.getDeliveryAddress(
            addQuoteLineRequest.shipTo.addressSelectionName ?? "",
            addQuoteLineRequest.shipTo.deliveryNameD365 ?? "",
            value ?? ""
          );
      }

      this.checkCurrencyMismatch(
        addQuoteLineRequest,
        QuotesCheckCurrencyMismatchCallingMethod.onSubmitMethodCreateQuoteLine,
        ""
      );
    }
  }

  showPositionDialogDescription(
    position:
      | "center"
      | "top"
      | "bottom"
      | "left"
      | "right"
      | "topleft"
      | "topright"
      | "bottomleft"
      | "bottomright"
  ) {
    this.position = position;
    this.displayPositionDescription = true;
    this.stockPhraseDescription.flag = "description";
    this.stockPhraseDescription.selectedStock = [];
    this.stockPhraseDescription.getStockPhraseData();
  }

  showPositionDialogFactory(
    position:
      | "center"
      | "top"
      | "bottom"
      | "left"
      | "right"
      | "topleft"
      | "topright"
      | "bottomleft"
      | "bottomright"
  ) {
    this.position = position;
    this.displayPositionFactory = true;
    this.stockPhraseFactory.flag = "factory";
    this.stockPhraseFactory.selectedStock = [];
    this.stockPhraseFactory.getStockPhraseData();
  }

  closePositionDialogDescription() {
    this.displayPositionDescription = false;
  }

  closePositionDialogFactory() {
    this.displayPositionFactory = false;
  }

  getDescription(event: StockPhrase[]) {
    let description = "";
    event.forEach(element => {
      if (element.description) {
        if (description == "") {
          description += element.description;
        } else {
          description += "\n" + element.description;
        }
      }
    });

    this.quoteItemLine.patchValue({
      lines: {
        lineDescriptionD365: description,
      },
    });

    this.closePositionDialogDescription();
  }

  getFactory(event: StockPhrase[]) {
    let fact = "";
    event.forEach(element => {
      if (element.notes) {
        if (fact == "") {
          fact += element.notes;
        } else {
          fact += "\n" + element.notes;
        }
      }
    });

    this.quoteItemLine.patchValue({
      lines: {
        factoryNotes: fact,
      },
    });

    this.closePositionDialogFactory();
  }

  collapseStatus = false;
  expandStatus = true;
  collapseHeading = "Collapse all";

  getStateOfCollapseAll() {
    const status = localStorage.getItem("quote-line-collapse");
    if (status) {
      if (status === "true") {
        this.collapseStatus = true;
        this.expandStatus = false;
        this.collapseHeading = "Expand all";
      } else {
        this.collapseStatus = false;
        this.expandStatus = true;
        this.collapseHeading = "Collapse all";
      }
    }
  }

  getDeliveryAddress(
    addressSelectionName: string,
    deliveryNameD365: string,
    shipToVendorAccountNameD365: string
  ) {
    if (addressSelectionName.toLowerCase().includes("one")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("bill")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("vendor")) {
      return shipToVendorAccountNameD365;
    } else if (addressSelectionName.toLowerCase().includes("address")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("branding")) {
      return deliveryNameD365;
    }
    return "";
  }

  onToggle() {
    if (this.expandStatus) {
      this.collapseStatus = true;
      this.expandStatus = false;
      this.setStateOfExpandAll();
      this.collapseHeading = "Expand all";
    } else {
      this.collapseStatus = false;
      this.expandStatus = true;
      this.setStateOfCollapseAll();
      this.collapseHeading = "Collapse all";
    }
  }

  setStateOfExpandAll() {
    localStorage.setItem("quote-line-collapse", "true");
  }

  setStateOfCollapseAll() {
    localStorage.setItem("quote-line-collapse", "false");
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  redirectToCopiedFrom() {
    if (this.quoteLineObject?.lineCopiedFrom) {
      if (this.quoteLineObject?.lineCopiedFrom === EnumCopiedFrom.IsFromOrder) {
        const url = `/orders/order-summary/${this.quoteLineObject.lineCopiedFromHeaderId}`;
        window.open(url, "_blank");
      } else if (
        this.quoteLineObject?.lineCopiedFrom === EnumCopiedFrom.IsFromQuote
      ) {
        const url = `/proposal/quote-summary/${this.quoteLineObject.lineCopiedFromHeaderId}`;
        window.open(url, "_blank");
      }
    }
  }

  setCopiedFromInfo() {
    let copiedInfo = "";

    if (this.quoteLineObject?.lineCopiedFromPurchaseOrderD365) {
      copiedInfo =
        " PO " +
        this.quoteLineObject?.lineCopiedFromPurchaseOrderD365 +
        "   Line " +
        this.quoteLineObject?.lineCopiedFromLineNumberD365 +
        "   ";
    } else if (this.quoteLineObject?.lineCopiedFromHeaderId) {
      if (this.quoteLineObject.lineCopiedFrom === EnumCopiedFrom.IsFromOrder) {
        copiedInfo =
          " Ord " +
          this.quoteLineObject?.lineCopiedFromHeaderId +
          "   Line " +
          this.quoteLineObject?.lineCopiedFromLineNumberD365 +
          "   ";
      } else if (
        this.quoteLineObject.lineCopiedFrom === EnumCopiedFrom.IsFromQuote
      ) {
        copiedInfo =
          " Proposal " +
          this.quoteLineObject?.lineCopiedFromHeaderId +
          "   Line " +
          this.quoteLineObject?.lineCopiedFromLineNumberD365 +
          "   ";
      }
    }
    return copiedInfo;
  }

  checkCurrencyMismatch(
    saleOrderLineRequest: UpdateQuotesLineDto | QuotesLineRequestDto,
    callFromMethod: string,
    lineAction: string
  ) {
    if (
      saleOrderLineRequest?.vendor &&
      (saleOrderLineRequest?.vendor?.vendorPoAssignment === "Default" ||
        saleOrderLineRequest?.vendor?.vendorPoAssignment === "Existing")
    ) {
      if (saleOrderLineRequest?.lines) {
        const checkCurrencyMismatchRequest: CheckCurrencyMismatchRequestDto = {
          currencyCode: Array.isArray(saleOrderLineRequest.lines)
            ? saleOrderLineRequest.lines[0]?.currencyCodeD365
            : saleOrderLineRequest.lines?.currencyCodeD365,
          purchaseOrderId:
            (saleOrderLineRequest as QuotesLineRequestDto)?.purchaseOrderId ??
            "",
          salesOrderId:
            (saleOrderLineRequest as QuotesLineRequestDto)?.saleOrderId ??
            this.quoteId,
          vendorDirectDelivery:
            saleOrderLineRequest?.vendor?.vendorDirectDelivery ?? "",
          vendorPoAssignment:
            saleOrderLineRequest?.vendor?.vendorPoAssignment ?? "",
          isnetInForeignCurrencyStatus: Array.isArray(
            saleOrderLineRequest?.lines
          )
            ? saleOrderLineRequest?.lines[0]?.isnetInForeignCurrencyStatus
            : saleOrderLineRequest?.lines?.isnetInForeignCurrencyStatus,
        };

        if (
          checkCurrencyMismatchRequest.isnetInForeignCurrencyStatus !== true
        ) {
          checkCurrencyMismatchRequest.isnetInForeignCurrencyStatus = false;
        }

        this._loaderService.setLoaderState(true);
        this._createHeaderQuoteService
          .checkCurrencyMismatch(checkCurrencyMismatchRequest)
          .pipe(untilDestroyed(this))
          .subscribe({
            next: res => {
              this._loaderService.setLoaderState(false);
              if (res.status.toLowerCase() == "success") {
                if (res?.data && res?.data?.isMismatch === true) {
                  this._toastr.error(
                    "Error",
                    res.message || "Currency must be the same"
                  );
                } else {
                  if (
                    callFromMethod ===
                    QuotesCheckCurrencyMismatchCallingMethod.onSubmitMethodCreateQuoteLine
                  ) {
                    if ("saleOrderId" in saleOrderLineRequest) {
                      this.onSubmitMethodcreateQuoteLine(saleOrderLineRequest);
                    }
                  } else if (
                    callFromMethod ===
                    QuotesCheckCurrencyMismatchCallingMethod.onSubmitMethodUpdateQuoteLine
                  ) {
                    if ("id" in saleOrderLineRequest) {
                      this.onSubmitMethodUpdateQuoteLine(saleOrderLineRequest);
                    }
                  } else if (
                    callFromMethod ===
                    QuotesCheckCurrencyMismatchCallingMethod.nextMethodCreateQuoteLine
                  ) {
                    if ("saleOrderId" in saleOrderLineRequest) {
                      this.nextMethodCreateQuoteLine(
                        saleOrderLineRequest,
                        lineAction
                      );
                    }
                  } else if (
                    callFromMethod ===
                    QuotesCheckCurrencyMismatchCallingMethod.nextMethodUpdateQuoteLine
                  ) {
                    if ("id" in saleOrderLineRequest) {
                      this.nextMethodUpdateQuoteLine(saleOrderLineRequest);
                    }
                  }
                }
              }
            },
            error: res => {
              this._loaderService.setLoaderState(false);
              this._toastr.error(
                "Error",
                res.message || "Error checking the currecny validation"
              );
            },
          });
      }
    } else {
      if (
        callFromMethod ===
        QuotesCheckCurrencyMismatchCallingMethod.onSubmitMethodCreateQuoteLine
      ) {
        if ("saleOrderId" in saleOrderLineRequest) {
          this.onSubmitMethodcreateQuoteLine(saleOrderLineRequest);
        }
      } else if (
        callFromMethod ===
        QuotesCheckCurrencyMismatchCallingMethod.onSubmitMethodUpdateQuoteLine
      ) {
        if ("id" in saleOrderLineRequest) {
          this.onSubmitMethodUpdateQuoteLine(saleOrderLineRequest);
        }
      } else if (
        callFromMethod ===
        QuotesCheckCurrencyMismatchCallingMethod.nextMethodCreateQuoteLine
      ) {
        if ("saleOrderId" in saleOrderLineRequest) {
          this.nextMethodCreateQuoteLine(saleOrderLineRequest, lineAction);
        }
      } else if (
        callFromMethod ===
        QuotesCheckCurrencyMismatchCallingMethod.nextMethodUpdateQuoteLine
      ) {
        if ("id" in saleOrderLineRequest) {
          this.nextMethodUpdateQuoteLine(saleOrderLineRequest);
        }
      }
    }
  }

  onSubmitMethodcreateQuoteLine(addQuoteLineRequest: QuotesLineRequestDto) {
    this._loaderService.setLoaderState(true);
    this._createHeaderQuoteService
      .createQuoteLine(addQuoteLineRequest)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this._toastr.success(
              "Success",
              res.message || "line item added successfully"
            );
            if (res.data?.length && res.data[0].salesOrderIdD365) {
              const url = `/proposal/quote-summary/${res.data[0]?.salesOrderIdD365}`;
              this.route.navigate([url]);
            } else {
              const url = `/proposal/quote-summary/${this.quoteId}`;
              this.route.navigate([url]);
            }
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error adding line item"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error adding line item");
        },
      });
  }

  onSubmitMethodUpdateQuoteLine(updateQuoteLineRequest: UpdateQuotesLineDto) {
    this._loaderService.setLoaderState(true);
    this._createHeaderQuoteService
      .updateQuoteLine(updateQuoteLineRequest)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this._toastr.success(
              "Success",
              res.message || "line item update successfully"
            );
            if (this.quoteModalStatus) {
              this.closeEvent.emit();
              return;
            }

            //After V2
            if (res?.data === true) {
              const url = `/proposal/quote-summary/${this.quoteId}`;
              this.route.navigate([url]);
            }

            //Previously code was before v2
            // if (res.data?.length && res.data[0]?.salesOrderIdD365) {
            //   const url = `/proposal/quote-summary/${res.data[0]?.salesOrderIdD365}`;
            //   this.route.navigate([url]);
            // } else {
            //   const url = `/proposal/quote-summary/${this.quoteId}`;
            //   this.route.navigate([url]);
            // }
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error updating line item"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error adding line item");
        },
      });
  }

  nextMethodCreateQuoteLine(
    addQuoteLineRequest: QuotesLineRequestDto,
    lineAction: string
  ) {
    if (this.onSubmitDone || this.copyCase) {
      this._loaderService.setLoaderState(true);
      this._createHeaderQuoteService
        .createQuoteLine(addQuoteLineRequest)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this._toastr.success(
                "Success",
                res.message || "line item added successfully"
              );

              if (lineAction === "Add Line") {
                this.copyCase = true;
                this.quickEntyFieldStatus = "Add Line";
                this.orderLineNumber = "";
                this.lineId = 0;
                this.getQuoteData();
                this.clearSaleOrderLineForm();
                this.lineDetail.clearLineForm();
                this.shipTo.clearShipToAddressForm();
                this.details.clearInHandDateAndShipDate();
                this.lineDetail.disabledNetConversionCurrencyField();
              } else if (lineAction === "Copy Header") {
                this.copyCase = true;
                this.quickEntyFieldStatus = "Copy Header";
                this.orderLineNumber = "";
                this.lineId = 0;
                this.getQuoteData();
                this.clearLineData();
                this.lineDetail.clearLineForm();
                this.lineDetail.disabledNetField();
              } else if (lineAction === "Copy Line") {
                this.copyCase = true;
                this.orderLineNumber = "";
                this.lineId = 0;
                this.quickEntyFieldStatus = "Copy Line";
                this.getQuoteData();
              } else if (lineAction === "Add Setup") {
                this.copyCase = true;
                this.orderLineNumber = "";
                this.lineId = 0;
                this.quickEntyFieldStatus = "Add Setup";
                this.getQuoteData();
                this.clearLineData();
                this.lineDetail.clearLineForm();
                this.lineDetail.disabledNetField();
                this.patchValueInSetup();
              }
              if (this.orderLineNumber) {
                this.orderItemLineNumber = parseFloat(
                  this.orderLineNumber || "1"
                );
              } else {
                this.getLineNumber(this.quoteId);
              }
              this.unTouchForm();
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error adding line item"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error adding line item"
            );
          },
        });
    } else {
      if (lineAction === "Add Line") {
        this.copyCase = true;
        this.quickEntyFieldStatus = "Add Line";
        this.orderLineNumber = "";
        this.lineId = 0;
        this.getQuoteData();
        this.clearSaleOrderLineForm();
        this.lineDetail.clearLineForm();
        this.shipTo.clearShipToAddressForm();
        this.details.clearInHandDateAndShipDate();
        this.lineDetail.disabledNetConversionCurrencyField();
      } else if (lineAction === "Copy Header") {
        this.copyCase = true;
        this.quickEntyFieldStatus = "Copy Header";
        this.orderLineNumber = "";
        this.lineId = 0;
        this.getQuoteData();
        this.clearLineData();
        this.lineDetail.clearLineForm();
        this.lineDetail.disabledNetField();
      } else if (lineAction === "Copy Line") {
        this.copyCase = true;
        this.orderLineNumber = "";
        this.lineId = 0;
        this.quickEntyFieldStatus = "Copy Line";
        this.getQuoteData();
      } else if (lineAction === "Add Setup") {
        this.copyCase = true;
        this.orderLineNumber = "";
        this.lineId = 0;
        this.quickEntyFieldStatus = "Add Setup";
        this.getQuoteData();
        this.clearLineData();
        this.lineDetail.clearLineForm();
        this.lineDetail.disabledNetField();
        this.patchValueInSetup();
      }
      if (this.orderLineNumber) {
        this.orderItemLineNumber = parseFloat(this.orderLineNumber || "1");
      } else {
        this.getLineNumber(this.quoteId);
      }
    }
  }

  nextMethodUpdateQuoteLine(updateQuoteLineRequest: UpdateQuotesLineDto) {
    this._loaderService.setLoaderState(true);
    this._createHeaderQuoteService
      .updateQuoteLine(updateQuoteLineRequest)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this._toastr.success(
              "Success",
              res.message || "line item update successfully"
            );
            // if (this.orderLineNumber) {
            //   if (res?.data?.salesOrderLines) {
            //     const saleOrderLineList = res?.data?.salesOrderLines.filter(
            //       (x: any) => x.id === parseInt(this.orderLineNumber)
            //     );
            //     if (saleOrderLineList[0]) {
            //       const number = saleOrderLineList[0]?.lineNumberD365;
            //       this.orderItemLineNumber = number || 1;
            //     }
            //   }
            //   this.clearSaleOrderLineForm();
            //   this.lineDetail.clearLineForm();
            //   this.shipTo.clearShipToAddressForm();
            //   this.route.navigate(["/proposal/add-line/" + this.quoteId]);
            // } else {
            //   this.getLineNumber(this.quoteId);
            // }
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error updating line item"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error adding line item");
        },
      });
  }

  closeProposalLineModal() {
    this.closeEvent.emit();
  }
}
